import {PALETTE_NAMES, COLOR_ALIASES} from './palettes';

/**
 * Resolve a color name to a valid palette key.
 *
 * Resolution order:
 *   1. Exact match against allowedColors (if provided) or all palette names.
 *   2. Alias lookup (e.g. "indigo" → "blue").
 *   3. Fallback (defaults to "neutral").
 *
 * @param {string|undefined} color  — requested color name
 * @param {Object}  [opts]
 * @param {string[]} [opts.allowedColors] — restrict to these palette names
 * @param {string}   [opts.fallback]      — fallback color (default: "neutral")
 * @returns {string} — a valid palette key
 */
export function resolveColor(color, {allowedColors, fallback = 'neutral'} = {}) {
	if (!color) return fallback;

	const pool = allowedColors?.length ? allowedColors : PALETTE_NAMES;

	if (pool.includes(color)) return color;

	const aliased = COLOR_ALIASES[color];
	if (aliased && pool.includes(aliased)) return aliased;

	return fallback;
}
